import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {Language} from "../../types";

interface Props {
  classname?: string;
  language: Language;
}

export const ChangeLanguage: React.FC<Props> = ({classname, language}) => {
  const {i18n} = useTranslation();

  const handleChangeLanguage = (language: Language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", JSON.stringify(language));
  };

  useEffect(() => {
    localStorage.setItem("language", JSON.stringify(i18n.language));
  }, []);

  return (
    <button
      style={{
        color: i18n.language === language ? "#005EFF" : "#fff",
      }}
      className={classname}
      onClick={() => handleChangeLanguage(language)}
    >
      {language.toLocaleUpperCase()}
    </button>
  );
};
